module.exports = __webpack_public_path__ + "img/pic-1.4d9941db.png";